import {useQuery} from '@tanstack/react-query';
import {TypeLocalNameEnum} from 'domain/usecases';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {EntryPointCodeEnum} from 'presentation/constants/entryPointCodeEnum';
import {TelemedicineEnum} from '../../constants/telemedicineEnum';
import {getHealthSpecialties} from '../../services/getHealthSpecialties';
import {useBookingStore} from '../../store/useBookingStore';
import {UseGetHealthSpecialtiesQueryProps} from './types';

function useGetHealthSpecialtiesQuery({
	isTelemedicine,
	enabled = true,
}: UseGetHealthSpecialtiesQueryProps) {
	const bookingData = useBookingStore(state => state.bookingData);

	const {ufCode, cityName, typeLocalName, isManualLocation, coordinates} = bookingData;

	const params = {
		cityName:
			bookingData.isManualLocation || isTelemedicine ? cityName?.toUpperCase() : coordinates,
		stateCode: isManualLocation || isTelemedicine ? ufCode?.toUpperCase() : '',
		entryPointCode: Number(EntryPointCodeEnum.V2),
		telemedicine: isTelemedicine ? TelemedicineEnum.IS_TELEMEDICINE : '',
		typeLocalName: typeLocalName || TypeLocalNameEnum.CIDADE,
	};

	return useQuery({
		queryKey: [QUERY_KEYS.HEALTH_SPECIALTIES, params],
		enabled,
		queryFn: async ({signal}) => getHealthSpecialties({signal, ...params}),
		retry: 1,
	});
}

export {useGetHealthSpecialtiesQuery};
